/* eslint-disable array-bracket-newline */
/**
 * Implements a chart picker
 * Contains a list of chart modes
 */
import { useState } from 'react';
import { Link } from 'react-router-dom';
import Image from '../../atoms/Image';
import Text from '../../atoms/Text';
import { Item, List } from '../../molecules/Dropdown';
import research from '../../assets/images/research.svg';
import shevron from '../../assets/images/shevron_down.svg';

import './styles.scss';

const Research = () => {
  const [opened, setOpened] = useState(false);

  const pathname = window.location.pathname.split('/')[1];

  const isResearch = pathname
    ? ['new-pairs', 'big-trades', 'profitable-wallets', 'coins'].includes(pathname)
    : false;

  return (
    <div className={`research ${isResearch ? 'research--active' : ''}`}>
      <div className='research__block' onClick={() => setOpened(true)}>
        <Image src={research} size='m' />
        <Text size={12} className='research__block__text'>
          Research
        </Text>
        <Image size='m' src={shevron} className='research__dropdown_icon' />
      </div>
      {opened && (
        <>
          <div
            className='research__backdrop'
            onClick={() => setOpened(false)}
          />
          <List className='research__list'>
            <Item>
              <Link
                to='/new-pairs?chain=ETH&page=1'
                className='research__list__item'
              >
                <Text size={14} className='text--grey-400 text--weight-600'>
                  New pairs
                </Text>
              </Link>
            </Item>
            <Item>
              <Link to='/big-trades?chain=ETH' className='research__list__item'>
                <Text size={14} className='text--grey-400 text--weight-600'>
                  Big trades
                </Text>
              </Link>
            </Item>
            {/* <Item>
              <div className="research__list__item">
                <Text size={14} className="text--grey-400 text--weight-600">Profitable wallets</Text>
              </div>
              </Item>
              <Item>
              <Link to="/coins/KTN" className="research__list__item">
                <Text size={14} className="text--grey-400 text--weight-600">Coins</Text>
              </Link>
            </Item> */}
          </List>
        </>
      )}
    </div>
  );
};

export default Research;
